import type {
    SerializedDocument,
    SerializedMedia,
    SerializedVoiceover,
} from './dashboardSketchStorage';

import type { UploadedFile } from 'js/src/components/sketch/FileUpload';
import { isUploadedAudio, isUploadedMedia } from 'js/src/components/sketch/FileUpload';

/**
 * Splits the chat input's attachments into the three buckets the sketch
 * hand-off payload expects. Files still uploading (no uuid) and documents
 * without extracted text are dropped, since the destination cannot use them.
 */
export function serializeSketchFiles(files: UploadedFile[]): {
    documents: SerializedDocument[];
    media: SerializedMedia[];
    voiceovers: SerializedVoiceover[];
} {
    const documents: SerializedDocument[] = [];
    const media: SerializedMedia[] = [];
    const voiceovers: SerializedVoiceover[] = [];

    for (const file of files) {
        if (isUploadedAudio(file) && file.uuid) {
            voiceovers.push({
                id: file.id,
                name: file.name,
                type: file.type,
                uuid: file.uuid,
            });
        } else if (isUploadedMedia(file) && file.uuid) {
            media.push({
                id: file.id,
                name: file.name,
                type: file.type,
                uuid: file.uuid,
            });
        } else if (!isUploadedMedia(file) && !isUploadedAudio(file) && file.url && file.text) {
            documents.push({
                id: file.id,
                name: file.name,
                type: file.type,
                url: file.url,
                text: file.text,
            });
        }
    }

    return { documents, media, voiceovers };
}
